var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.selected_calculationcode,"items":_vm.calculationcodes,"item-value":"calculationcode","item-text":"calculationcodename","label":_vm.label,"dense":"","clearable":_vm.selection_clearable},on:{"change":_vm.updateData}})
}
var staticRenderFns = []

export { render, staticRenderFns }